/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskStatesEnum } from './taskStatesEnum';
import { RolloutActionType } from './rolloutActionType';


export interface TaskActionResultSummary { 
    type?: RolloutActionType;
    state?: TaskStatesEnum;
}
export namespace TaskActionResultSummary {
}


